import { rootApi } from '../rootApi';

export const administrationPagesApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getListAdministrationPages: builder.query({
            query: (params = {}) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.PageNumber !== undefined ? params.PageNumber : 1);
                queryParams.append('PageSize', params.PageSize || 10);
                queryParams.append('SearchText', params.SearchText || '');
                queryParams.append('LanguageId', params.LanguageId || 2); // Default TR dil ID'si

                if (params.FirstName) queryParams.append('FirstName', params.FirstName);
                if (params.LastName) queryParams.append('LastName', params.LastName);
                if (params.Role !== undefined && params.Role !== null && params.Role !== '') {
                    queryParams.append('Role', params.Role);
                }
                if (params.SortField) queryParams.append('SortField', params.SortField);
                if (params.SortOrder) queryParams.append('SortOrder', params.SortOrder);

                return {
                    url: `v1/AdministrationPages/GetAll?${queryParams.toString()}`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => {
                if (response && response.isSuccessful && response.data) {
                    return {
                        items: response.data.items || [],
                        totalCount: response.data.totalCount || 0,
                    };
                }
                return {
                    items: [],
                    totalCount: 0,
                };
            },
            providesTags: ['AdministrationPages'],
        }),

        getAdministrationPageById: builder.query({
            query: (id) => ({
                url: `v1/AdministrationPages/GetById/${id}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                if (response && response.isSuccessful && response.data) {
                    return response.data;
                }
                return null;
            },
            providesTags: (result, error, id) => [{ type: 'AdministrationPages', id }],
        }),

        saveAdministrationPage: builder.mutation({
            query: (data) => ({
                url: 'v1/AdministrationPages/Save',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['AdministrationPages'],
        }),

        updateAdministrationPage: builder.mutation({
            query: (data) => ({
                url: 'v1/AdministrationPages/Update',
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: (result, error, data) => [{ type: 'AdministrationPages', id: data.Id }],
        }),

        deleteAdministrationPage: builder.mutation({
            query: (id) => ({
                url: 'v1/AdministrationPages/Delete',
                method: 'DELETE',
                body: { Id: id },
            }),
            invalidatesTags: ['AdministrationPages'],
        }),

        getUserList: builder.query({
          query: (params = {}) => {

                const languageId = typeof params === 'object' ? params.languageId : params;
                const firstName = typeof params === 'object' ? params.firstName : undefined;
                const lastName = typeof params === 'object' ? params.lastName : undefined;
                const role = typeof params === 'object' ? params.role : undefined;

                const queryParams = new URLSearchParams();
                queryParams.append('LanguageId', languageId || 2);
                
                if (firstName) {
                    queryParams.append('FirstName', firstName);
                }
                if (lastName) {
                    queryParams.append('LastName', lastName);
                }
                if (role) {
                    queryParams.append('Role', role);
                }

                return {
                    url: `v1/AdministrationPages/GetUserList?${queryParams.toString()}`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => {
                if (response && response.isSuccessful && response.data && Array.isArray(response.data.items)) {
                    return response.data.items;
                }
                return [];
            },
            providesTags: ['UserList'],
        }),

        getRoleList: builder.query({
            query: (languageId) => ({
                url: 'v1/AdministrationPages/GetRoleList',
                method: 'GET',
                params: { LanguageId: languageId },
            }),
            transformResponse: (response) => {
                if (response && response.isSuccessful && response.data && Array.isArray(response.data.items)) {
                    return response.data.items;
                }
                return [];
            },
            providesTags: ['RoleList'],
        }),
    }),
});

export const {
    useGetListAdministrationPagesQuery,
    useGetAdministrationPageByIdQuery,
    useSaveAdministrationPageMutation,
    useUpdateAdministrationPageMutation,
    useDeleteAdministrationPageMutation,
    useGetUserListQuery,
    useGetRoleListQuery,
    useLazyGetUserListQuery,
    useLazyGetRoleListQuery,
} = administrationPagesApi;